import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'

const IconContainer = styled.div`
  width: ${rem(48)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  color: ${props => props.theme.palette.highlight.primary.lightContrast};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  isSelected?: boolean
  onClick?: () => void
}

function CruiseLinesSearchListAll({ isSelected, onClick }: Props) {
  const intl = useIntl()

  const allCruiseLinesTitle = intl.formatMessage({
    id: 'QsDUHkJs4tkwuTUPUSzV',
    defaultMessage: 'All cruise lines',
    description: 'Heading title for the option to select all cruise lines',
  })

  return <ClickableListItem
    data-testid="cruise-line-select-list-all"
    onClick={onClick}
    title={<b>{allCruiseLinesTitle}</b>}
    startIcon={<IconContainer>
      <LineShipIcon size="M" />
    </IconContainer>}
    endIcon={<CheckboxButton size="large" checked={isSelected} />}
  />
}

export default CruiseLinesSearchListAll
